// extracted by mini-css-extract-plugin
export default {"gallery":"c-m_hm","gallery__header":"c-m_hn","gallery__thumbs":"c-m_ho"};